<div class="container">
    <mat-card appearance="outlined">
        <mat-card-title>Purchase Orders</mat-card-title>
          <!-- add Button -->
            <button mat-mini-fab color="accent" aria-label="Add" (click)="navigateToAddPo()" class="add-btn" [disabled]="!isAdminGroupUser">
                <mat-icon>add</mat-icon>
            </button>
        <!-- Download Button -->
            <button mat-mini-fab color="accent"  class="download-btn" (click)="downloadAllRecords()"
               *ngIf="dataSource.data.length > 0"  matTooltip="Download Records" >
                <mat-icon>download</mat-icon>
            </button>
        <mat-card-content>
            <div class="row" style="padding: 5px">
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 col-xxl-5">
                        <app-search-input [label]="'Search by PO Number'"
                            [placeholder]="'Enter PO number and hit Enter'" [tooltip]="'Search by Po number.'"
                            (search)="searchByPoNumber($event)" (cleared)="onClearSearch()">
                        </app-search-input>
                    </div>
                    <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
                        <app-column-selector [allColumns]="allColumns" [defaultColumns]="defaultColumns"
                            storageKey="findiPoDisplayedColumns" [(value)]="displayedColumns">
                        </app-column-selector>
                    </div>
                    <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                        <app-filter-input *ngIf="dataSource.data.length  > 0"
                            (filterChanged)="applyFilter($event)"></app-filter-input>
                    </div>
                </div>
                <div class="row" style="margin: auto">
                    <div class="wrapper">
                        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort
                            aria-label="Purchase order table" (matSortChange)="announceSortChange($event)"
                            *ngIf="dataSource.data.length > 0">
                            <ng-container matColumnDef="findiPurchaseOrderId">
                                <td mat-cell *matCellDef="let element">
                                    {{ element.findiPurchaseOrderId }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="poNumber">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    sortActionDescription="Sort by Po Number">
                                    PoNumber
                                </th>
                                <td mat-cell *matCellDef="let element; let i = index">
                                    <a (click)="showOrderDetails($event, element)">{{
                                        element.poNumber
                                        }}</a>
                                </td>
                            </ng-container>
                            
                             <ng-container matColumnDef="parentPo">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    sortActionDescription="Sort by Parent Po">
                                    Parent Po
                                </th>
                                <td mat-cell *matCellDef="let element; let i = index">
                                   {{element.parentPo}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="orderDetailsCount">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    sortActionDescription="Sort by Details Count">
                                    PO-Details
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.orderDetailsCount }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="orderDate">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    sortActionDescription="Sort by Order Date">
                                    Order Date
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.orderDate | date : "dd-MMM-yyyy" }}
                                </td>
                            </ng-container>


                            <ng-container matColumnDef="orderQuantity">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    sortActionDescription="Sort by Details Count">
                                    Order Qty
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.orderQuantity }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="receivedQuantity">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    sortActionDescription="Sort by Details Count">
                                    Rx Qty
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.receivedQuantity }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="address">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    sortActionDescription="Sort by address">
                                    Address
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.address }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="description">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    sortActionDescription="Sort by description">
                                    Description
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.description }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="vendorCode">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    sortActionDescription="Sort by Vendor Code">
                                    Vendor
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.vendorCode }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="createdBy">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    sortActionDescription="Sort by Created By">
                                    Created By
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.createdBy }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="createdOn">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    sortActionDescription="Sort by createdOn">
                                    Created On
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.createdOn | date : "dd-MMM-yyyy" }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="updatedBy">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    sortActionDescription="Sort by Updated By">
                                    Updated By
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.updatedBy }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="updatedOn">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    sortActionDescription="Sort by updatedOn">
                                    Updated On
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.updatedOn | date : "dd-MMM-yyyy" }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="updateRemarks">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    sortActionDescription="Sort by updateRemarks">
                                    Update Remarks
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.updateRemarks }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="addChild">
                                <th mat-header-cell *matHeaderCellDef> Add Child </th>
                                <td mat-cell *matCellDef="let element">
                                    <button mat-mini-fab aria-label="Edit"
                                        matTooltip ='Add child purchase order and details'
                                        [disabled]= "!isAdminGroupUser" 
                                        (click)="addChildDetails($event, element)">
                                        <mat-icon>add</mat-icon>
                                    </button>
                                </td>
                            </ng-container>
                               <ng-container matColumnDef="addMore">
                                <th mat-header-cell *matHeaderCellDef> Add More </th>
                                <td mat-cell *matCellDef="let element">
                                    <button mat-mini-fab aria-label="Edit"
                                        matTooltip ='Add more purchase order details'
                                        [disabled]= "!isAdminGroupUser" 
                                        (click)="addMoreDetails($event, element)">
                                        <mat-icon>library_add</mat-icon>
                                    </button>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="edit">
                                <th mat-header-cell *matHeaderCellDef> Edit </th>
                                <td mat-cell *matCellDef="let element">
                                    <!-- Wrap in span to enable tooltip even when disabled -->
                                    <span
                                        [matTooltip]="element.isAssetCreated ? 'Asset created for this order.' : 'Edit Purchase order'"
                                        matTooltipPosition="above">
                                        <button mat-mini-fab aria-label="Edit" [disabled]="element.isAssetCreated || !isAdminGroupUser"
                                            [ngClass]="{
                                                        'mat-mini-fab': true,
                                                        'mat-accent': !element.isAssetCreated,
                                                        'disabled-edit-button': element.isAssetCreated
                                                        }" 
                                            (click)="updatePurchaseOrder($event, element)">
                                            <mat-icon>create</mat-icon>
                                        </button>
                                    </span>
                                </td>
                            </ng-container>
                              <ng-container matColumnDef="delete">
                                <th mat-header-cell *matHeaderCellDef> Delete </th>
                                <td mat-cell *matCellDef="let element">
                                    <!-- Wrap in span to enable tooltip even when disabled -->
                                    <span
                                        [matTooltip]="element.isAssetCreated ? 'Asset created for this order.' : 'Delete Purchase order'"
                                        matTooltipPosition="above">
                                        <button mat-mini-fab aria-label="Delete" [disabled]="element.isAssetCreated || !isAdminGroupUser"
                                            [ngClass]="{
                                                        'mat-mini-fab': true,
                                                        'mat-accent': !element.isAssetCreated,
                                                        'disabled-edit-button': element.isAssetCreated
                                                        }" 
                                            (click)="softDelete($event, element)">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </span>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                        </table>
                        <div *ngIf="isLoaderResult" class="custSpinner"></div>
                    </div>
                </div>
            </div>
            <mat-paginator #paginator [length]="totalRows" [pageIndex]="currentPage" [pageSize]="pageSize"
                [pageSizeOptions]="pageSizeOptions" (page)="pageChanged($event)" aria-label="Select page">
            </mat-paginator>
        </mat-card-content>
    </mat-card>
</div>